import { render, staticRenderFns } from "./imgtext.vue?vue&type=template&id=583a9d1c"
import script from "./imgtext.vue?vue&type=script&lang=js"
export * from "./imgtext.vue?vue&type=script&lang=js"
import style0 from "./imgtext.vue?vue&type=style&index=0&id=583a9d1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports